import React from 'react';
import { useLang } from '../contexts/LanguageContext';

export default function PrivacyPage() {
  const { t } = useLang();

  const sections = [
    {
      title: { it: '1. Titolare del Trattamento', en: '1. Data Controller' },
      text: {
        it: "Il titolare del trattamento dei dati personali è biolosophy, con sede in Via Ofanto 24, 59100 Prato (PO), Italia — P.IVA IT08028200965, contattabile all'indirizzo info@biolosophy.it.",
        en: 'The data controller is biolosophy, based in Via Ofanto 24, 59100 Prato (PO), Italy — VAT no. IT08028200965, reachable at info@biolosophy.it.',
      },
    },
    {
      title: { it: '2. Dati Raccolti', en: '2. Data Collected' },
      text: {
        it: "Raccogliamo i dati necessari alla gestione dell'account e degli ordini: nome, indirizzo email, indirizzo di spedizione, storico ordini e richieste Biolosophy Value. I dati di pagamento sono gestiti esclusivamente dai provider Stripe e PayPal e non vengono memorizzati sui nostri sistemi.",
        en: 'We collect the data needed to manage accounts and orders: name, email address, shipping address, order history and Biolosophy Value requests. Payment data is handled exclusively by Stripe and PayPal and is never stored on our systems.',
      },
    },
    {
      title: { it: '3. Finalità del Trattamento', en: '3. Purposes of Processing' },
      text: {
        it: "I dati sono trattati per: gestione degli ordini e delle spedizioni, gestione dell'account e del programma Biolosophy Value, assistenza clienti, adempimenti fiscali e legali. Con il tuo consenso, potremo inviarti comunicazioni promozionali.",
        en: 'Data is processed for: order and shipping management, account and Biolosophy Value program management, customer support, tax and legal obligations. With your consent, we may send you promotional communications.',
      },
    },
    {
      title: { it: '4. Base Giuridica', en: '4. Legal Basis' },
      text: {
        it: "Il trattamento si fonda sull'esecuzione del contratto di acquisto (art. 6.1.b GDPR), su obblighi di legge (art. 6.1.c GDPR) e, per le finalità di marketing, sul consenso dell'interessato (art. 6.1.a GDPR).",
        en: 'Processing is based on the performance of the purchase contract (art. 6.1.b GDPR), legal obligations (art. 6.1.c GDPR) and, for marketing purposes, on the data subject\'s consent (art. 6.1.a GDPR).',
      },
    },
    {
      title: { it: '5. Conservazione dei Dati', en: '5. Data Retention' },
      text: {
        it: "I dati sono conservati per il tempo necessario alle finalità indicate e, in ogni caso, per i termini previsti dalla normativa fiscale (10 anni per i documenti contabili). L'account può essere cancellato in qualsiasi momento su richiesta.",
        en: 'Data is kept for as long as necessary for the stated purposes and, in any case, for the periods required by tax law (10 years for accounting documents). Accounts can be deleted at any time upon request.',
      },
    },
    {
      title: { it: '6. Condivisione dei Dati', en: '6. Data Sharing' },
      text: {
        it: 'I dati possono essere comunicati a: corrieri per la consegna degli ordini, provider di pagamento (Stripe, PayPal), fornitori di servizi tecnici. Non vendiamo né cediamo i tuoi dati a terzi per finalità di marketing.',
        en: 'Data may be shared with: couriers for order delivery, payment providers (Stripe, PayPal), technical service providers. We never sell or transfer your data to third parties for marketing purposes.',
      },
    },
    {
      title: { it: "7. Diritti dell'Interessato", en: '7. Data Subject Rights' },
      text: {
        it: "Ai sensi degli artt. 15-22 GDPR hai diritto di accedere ai tuoi dati, rettificarli, cancellarli, limitarne il trattamento, opporti al trattamento e richiederne la portabilità. Puoi esercitare i tuoi diritti scrivendo a info@biolosophy.it. Hai inoltre diritto di proporre reclamo al Garante per la Protezione dei Dati Personali.",
        en: 'Under articles 15-22 GDPR you have the right to access, rectify, delete, restrict processing of, object to processing of, and port your data. You can exercise your rights by writing to info@biolosophy.it. You also have the right to lodge a complaint with the Italian Data Protection Authority.',
      },
    },
    {
      title: { it: '8. Cookie', en: '8. Cookies' },
      text: {
        it: "Il sito utilizza cookie tecnici necessari al funzionamento (sessione, carrello, autenticazione) e, solo previo consenso, cookie statistici di Google Analytics con IP anonimizzato. Per il dettaglio completo e per gestire le preferenze consulta la Cookie Policy, raggiungibile dal footer del sito.",
        en: 'The site uses technical cookies necessary for operation (session, cart, authentication) and, only with prior consent, Google Analytics statistical cookies with anonymized IP. For full details and to manage preferences, see the Cookie Policy available in the site footer.',
      },
    },
    {
      title: { it: '9. Trasferimenti Extra-UE', en: '9. Transfers outside the EU' },
      text: {
        it: "Alcuni fornitori di servizi (es. Google Analytics, provider di pagamento) possono trasferire dati verso paesi extra-UE, in particolare gli USA. Tali trasferimenti avvengono sulla base di decisioni di adeguatezza della Commissione Europea (EU-US Data Privacy Framework) o di clausole contrattuali standard (SCC).",
        en: 'Some service providers (e.g. Google Analytics, payment providers) may transfer data to countries outside the EU, in particular the USA. Such transfers are based on European Commission adequacy decisions (EU-US Data Privacy Framework) or standard contractual clauses (SCC).',
      },
    },
    {
      title: { it: '10. Esercizio dei Diritti e Autodeterminazione', en: '10. Exercising Your Rights' },
      text: {
        it: "Dalla sezione \"Il Mio Account\" puoi in autonomia: scaricare una copia completa dei tuoi dati in formato leggibile (diritto alla portabilità, art. 20 GDPR) ed eliminare definitivamente il tuo account (diritto all'oblio, art. 17 GDPR). I dati degli ordini vengono resi anonimi ma conservati per gli obblighi fiscali di legge. Per ogni altra richiesta scrivi a info@biolosophy.it: risponderemo entro 30 giorni.",
        en: 'From the "My Account" section you can independently: download a full copy of your data in readable format (right to portability, art. 20 GDPR) and permanently delete your account (right to erasure, art. 17 GDPR). Order data is anonymized but retained for legal tax obligations. For any other request write to info@biolosophy.it: we will reply within 30 days.',
      },
    },
    {
      title: { it: '11. Minori', en: '11. Minors' },
      text: {
        it: "Il sito non è destinato a minori di 16 anni. Non raccogliamo consapevolmente dati personali di minori; se un genitore o tutore ritiene che un minore ci abbia fornito dati personali, può contattarci per la cancellazione immediata.",
        en: 'The site is not intended for children under 16. We do not knowingly collect personal data from minors; if a parent or guardian believes a minor has provided us with personal data, they can contact us for immediate deletion.',
      },
    },
    {
      title: { it: '12. Modifiche alla Presente Informativa', en: '12. Changes to this Policy' },
      text: {
        it: "Ci riserviamo di aggiornare questa informativa. Le modifiche sostanziali saranno comunicate tramite avviso sul sito. La data di ultimo aggiornamento è indicata in cima alla pagina.",
        en: 'We reserve the right to update this policy. Substantial changes will be communicated via a notice on the site. The last update date is shown at the top of the page.',
      },
    },
  ];

  return (
    <div data-testid="privacy-page" className="min-h-screen bg-[#FAF9F6] pt-24 pb-24">
      <section className="px-6 md:px-12 lg:px-24 py-16">
        <div className="max-w-3xl">
          <p className="overline mb-4">{t({ it: 'Legale', en: 'Legal' })}</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-light tracking-tighter text-[#1C1917] mb-4">
            Privacy Policy
          </h1>
          <p className="text-sm text-[#57534E] mb-16">
            {t({
              it: 'Ultimo aggiornamento: giugno 2026 — ai sensi del Reg. UE 2016/679 (GDPR)',
              en: 'Last updated: June 2026 — pursuant to EU Reg. 2016/679 (GDPR)',
            })}
          </p>

          <div className="space-y-10">
            {sections.map((s) => (
              <div key={s.title.it}>
                <h2 className="text-lg font-medium text-[#1C1917] mb-3">{t(s.title)}</h2>
                <p className="text-sm text-[#1C1917]/70 leading-relaxed">{t(s.text)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
